import { makeVar } from '@apollo/client';
import AsyncStorage from '@react-native-community/async-storage';
import { InMemoryCache } from '@apollo/client';

export const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        ProductBasketItems: {
          read() {
            return productBaksetItems();
          },
        },
      },
    },
  },
});

export const productBaksetItems = makeVar([]);

export const resetProductBasket = () => {
  productBaksetItems([]);
};

export const modifyProductBasket = ({ item, count }) => {
  const oldData = productBaksetItems();
  const existItemIndex = oldData.findIndex(
    ({ item: { id } }) => id === item.id
  );

  if (existItemIndex === -1) {
    productBaksetItems([...oldData, { count, item }]);
  } else {
    productBaksetItems([
      ...oldData.slice(0, existItemIndex),
      { count, item },
      ...oldData.slice(existItemIndex + 1),
    ]);
  }
};

export const clearCache = async (onClear) => {
  await AsyncStorage.clear();
  await cache.reset();
  onClear && onClear();
};
